import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./services.css";
import livingRoomImg from "../../images/living_room.jpg";
import balconyImg from "../../images/balcony.jpg";

const ServicesSection = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out",
      once: false,
    });
    AOS.refresh();
  }, []);
  return (
    <section id="services" style={{ width: "100%" }}>
      <div className="services-container">
        <div className="services-header">
          <div className="services-starter">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 256 256"
              className="services-icon"
            >
              <g opacity="0.2">
                <path d="M200,152l-40,40L96,176,40,136,72.68,70.63,128,56l55.32,14.63L183.6,72H144L98.34,116.29a8,8,0,0,0,1.38,12.42C117.23,139.9,141,139.13,160,120Z"></path>
              </g>
              <path d="M254.3,107.91,228.78,56.85a16,16,0,0,0-21.47-7.15L182.44,62.13,130.05,48.27a8.14,8.14,0,0,0-4.1,0L73.56,62.13,48.69,49.7a16,16,0,0,0-21.47,7.15L1.7,107.9a16,16,0,0,0,7.15,21.47l27,13.51,55.49,39.63a8.06,8.06,0,0,0,2.71,1.25l64,16a8,8,0,0,0,7.6-2.1l55.07-55.08,26.42-13.21a16,16,0,0,0,7.15-21.46Zm-54.89,33.37L165,113.72a8,8,0,0,0-10.68.61C136.51,132.27,116.66,130,104,122L147.24,80h31.81l27.21,54.41ZM41.53,64,62,74.22,36.43,125.27,16,115.06Zm116,119.13L99.42,168.61l-49.2-35.14,28-56L128,64.28l9.8,2.59-45,43.68-.08.09a16,16,0,0,0,2.72,24.81c20.56,13.13,45.37,11,64.91-5L188,152.66Zm62-57.87-25.52-51L214.47,64,240,115.06Zm-87.75,92.67a8,8,0,0,1-7.75,6.06,8.13,8.13,0,0,1-1.95-.24L80.41,213.33a7.89,7.89,0,0,1-2.71-1.25L51.35,193.26a8,8,0,0,1,9.3-13l25.11,17.94L126,208.24A8,8,0,0,1,131.82,217.94Z"></path>
            </svg>
            <span className="services-subtitle">Serviços</span>
          </div>
          <div className="services-title">
            <span className="highlight">
              Mais
              
            </span>
            reservas,
            <br />
            <span className="highlight">
              menos
             
            </span>
            preocupações
          </div>

          <p className="services-description">
            <span>
              Desde a decoração personalizada até à gestão diária e apoio ao
              hóspede ,
            </span>
            <span>
              tratamos de tudo — para que ganhes mais, com total tranquilidade.
            </span>
          </p>
        </div>
        <div className="services-content">
          <div className="feature-item reverse-layout">
            <div className="feature-text" data-aos="fade-left">
              <div className="feature-title">Aumenta os teus rendimentos</div>
              <p className="feature-description">

                <span>Melhoramos o teu espaço com </span> 
                <span>atenção ao detalhe para atrair mais</span>
                <span>mais reservas. Estamos sempre </span> 
                <span> disponíveis para os hóspedes e</span> 
                <span>ajudamos-nos a descobrir a cidade</span>  
                <span>como verdadeiros locais — o que </span> 
                <span>nos garante excelentes avaliações, </span> 
                <span>mais reservas e maior retorno.</span>
                
              </p>
            </div>
            <div className="feature-image-container" data-aos="fade-right">
              <img
                src={livingRoomImg}
                alt="A modern living room"
                className="feature-image"
              />
            </div>
          </div>
          <div className="feature-item">
            <div className="feature-text" data-aos="fade-right">
              <h2 className="feature-title">Deixa tudo connosco</h2>
              <p className="feature-description">
                <span>
                  Garantimos uma experiência de hóspede de excelência, com apoio{" "}
                </span>
                <span>
                   constante nas reservas, sugestões 
                </span>
                <span>
                  locais e resposta rápida a qualquer situação. Incluímos ainda serviços de
                  limpeza, manutenção e
                </span>
                <span>
                   melhorias no alojamento, para que tudo funcione sem sobressaltos.
                </span>
              </p>
            </div>
            <div className="feature-image-container" data-aos="fade-left">
              <img
                src={balconyImg}
                alt="A cozy balcony"
                className="feature-image"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
